import React, { createContext, useEffect, useReducer } from 'react';
import { gEnums } from '../../enums/globalEnums';
import { helpHandlers, helpInitialState, helpReducer } from '../reducers/HelpReducer';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';

/** 
@provides handleUpdateHelp 
*/
/**
 * help_state (helpDocs)- helpActions, helpDocuments, helpDocumentz, helpSettings, helpTopics
 * help_handlers (handleUpdate_help, handleUpdate_allHelp)
 */
export const HelpContext = createContext();

const HelpProvider = (props) => {

  const appUserAccess = useAppUserAccess()

  const init_state = {}
  const [help_state, help_dispatch] = useReducer(helpReducer, init_state, helpInitialState)
  const help_handlers = helpHandlers(help_dispatch, help_state)

  useEffect(() => {
    if (appUserAccess) {
      const { accessLevel } = appUserAccess
      if (accessLevel >= gEnums.accessLevels.appDataAdmin.value) {
        // help_handlers.handleInit_help()
      }
    }

    // eslint-disable-next-line
  }, [appUserAccess]) // run once

  const providerContext = () => <HelpContext.Provider value={{ help_state, help_handlers }}>
    {props.children}
  </HelpContext.Provider>

  return (
    <React.Fragment>
      {providerContext()}
    </React.Fragment>
  )
}

export default HelpProvider